import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d9597bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "explain" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
import Radio from '@/materials/atoms/Radio.vue';
import { useStore } from '@/store/store';
import { changeTheme } from '@/logics/theme';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        const { format, THEME_SWITCH_MESSAGES } = useMessage();
        const onChange = (value) => {
            store.commit('setTheme', value);
            changeTheme(value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(format)(_unref(THEME_SWITCH_MESSAGES).TITLE)), 1),
                _createElementVNode("div", null, [
                    _createVNode(Radio, {
                        title: _unref(format)(_unref(THEME_SWITCH_MESSAGES).DARK),
                        group: "site_theme",
                        value: "Dark",
                        onClick: _cache[0] || (_cache[0] = ($event) => (onChange('Dark'))),
                        checked: _unref(store).getters.theme === 'Dark'
                    }, null, 8, ["title", "checked"]),
                    _hoisted_2,
                    _createVNode(Radio, {
                        title: _unref(format)(_unref(THEME_SWITCH_MESSAGES).LIGHT),
                        group: "site_theme",
                        value: "Light",
                        onClick: _cache[1] || (_cache[1] = ($event) => (onChange('Light'))),
                        checked: _unref(store).getters.theme === 'Light'
                    }, null, 8, ["title", "checked"])
                ])
            ], 64));
        };
    }
});
